module.exports = __webpack_public_path__ + "static/media/logo.eca7614c.png";